/**
 * @generated SignedSource<<b4f6d9a52175d233f0a8a0cd46cb69e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionCookiesConsentsConfiguration_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconClass",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultAcceptsCookiesValue",
      "storageKey": null
    }
  ],
  "type": "PageSectionCookiesConsentsConfiguration",
  "abstractKey": null
};

node.hash = "d6e790c21b8f012bbc51b16e5ded2cb8";

module.exports = node;
